module.exports = __webpack_public_path__ + "img/instagram.2988dd5d.png";